import axios from '@/lib/axios';
import { useQuery } from '@tanstack/react-query';
import { WeeklySummary } from '@/hooks/api/models';
import queryClient from '@/lib/queryClient';

/**
 * 2420. ワークスペースguide状態取得
 * [GET] /workspaces/:identifier/guide
 */
type Props = {
  identifier: string;
};

type WorkSpaceGuide = {
  guide: 'no_team' | 'solo_user' | 'no_product' | 'no_project' | null;
};

const workspaceGuide = (props: Props): Promise<WorkSpaceGuide> => {
  return axios.get(`/api/workspaces/${props.identifier}/guide`, { params: props });
};

export const useWorkspaceGuide = (props: Props) => {
  return useQuery({
    queryKey: queryKey(props),
    queryFn: () => workspaceGuide(props),
  });
};

export const useInvalidateWorkspaceGuide = (props: Props) => {
  const invalidate = async () => {
    await queryClient.invalidateQueries({ queryKey: queryKey(props) });
  };

  return { invalidate };
};

const queryKey = (props: Props) => {
  return ['workspaces', props.identifier, 'guide'];
};
